module.exports = {
  "argument": [
    {
      "name": "argument",
      "type": [
        "object"
      ],
      "example": {
        "move": "Function",
        "start": "Function",
        "end": "Function",
        "left": "Function",
        "right": "Function",
        "up": "Function",
        "down": "Function"
      },
      "description": {
        "en": "Object that can include a number of callbacks corresponding to the touch event. See the example for what callbacks are available. Pairing x-axis and y-axis callbacks is not recommended at this time",
        "ja": "タッチイベントに対応するコールバックをいくつか含むことができるオブジェクト。どのようなコールバックが利用できるかについては、例を参照してください。x 軸と y 軸のコールバックのペアリングは、現時点では推奨されていません。",
        "zh-Hans": "由响应事件的回调函数组成的对象。查看这些可用的回调函数示例。目前，用于X轴和Y轴的回调函数还不推荐使用"
      }
    }
  ],
  "props": [],
  "name": "v-touch",
  "directive": true
}